module.exports = __webpack_public_path__ + "img/news_red_en.d233ca7e.png";